import '../../sass/layout/page/page-blog.scss';

import '../sections/section-pagination';

import Swiper, {
    Pagination,
    Autoplay,
    EffectFade
} from 'swiper';
import myLazyLoad from '../vendors/lazyLoading';


myLazyLoad.update();


const filters = document.querySelector('.filters');
const btnFilters = document.querySelector('.filters__mobile-btn');

if (btnFilters) {
    btnFilters.addEventListener('click', (e) => {
        e.preventDefault();
        if (filters.classList.contains('active')) {
            filters.classList.remove('active');
        } else {
            filters.classList.add('active');
        }
    })
}

document.querySelectorAll('.blog-article').forEach(article => {
    article.addEventListener('click', function() {
        const link = article.querySelector('a.read-more');
        if (link) {
            window.location.href = link.href;
        }
    });
});